var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userType === 'company')?_c('SettingsCompany'):(_vm.userType === 'hacker')?_c('Settings'):_c('div',{staticClass:"settings container"},[_c('div',{staticClass:"settings__title raleway raleway-bold"},[_vm._v(" Settings ")]),_c('div',{staticClass:"settings__link-logout",on:{"click":_vm.logout}},[_vm._v(" Logout ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }